/* Shared react-datepicker locale registration + lookup
   -----------------------------------------------------
   Registers both English and Swedish locales with react-datepicker
   exactly once (on module load — repeated registrations are harmless
   since the library overwrites the previous entry). Components then
   pass `locale={datePickerLocale(i18n.language)}` on every <DatePicker>
   so the calendar header / month dropdown / day names follow the URL's
   `lang=en-us` or `lang=sv-se` setting.

   The locales themselves come from date-fns (which react-datepicker
   already depends on), so no extra dependency is added. */
import { registerLocale } from 'react-datepicker';
import enUS from 'date-fns/locale/en-US';
import sv from 'date-fns/locale/sv';

registerLocale('en-US', enUS);
registerLocale('sv-SE', sv);

/* Map i18next's language code (`en-us`, `sv-se`, `en`, `sv`, etc.) to
   the matching registered locale string. Falls back to en-US for any
   unknown value so existing date display never breaks. */
export const datePickerLocale = (i18nLang: string | undefined): string => {
  const lang = (i18nLang || '').toLowerCase();
  if (lang.startsWith('sv')) return 'sv-SE';
  return 'en-US';
};
